// This is just an example,
// so you can safely delete all default props below

export default {
    signin_title: 'Logg inn',
    signin_desc: '',
    signin: 'Logg inn',
    email: 'E-post',
    password: 'Passord',
    remember_me: 'Husk meg',
    signup: 'Registrer',
    forget_password: 'Glemt passord?',
    stay_signed_in: 'Forbli innlogget?',
    error_email: 'E-post er ikke gyldig',
    error_password: 'Passord må oppgis',
    error_sign_in: 'E-post og passordkombinasjonen er ikke korrekt'
}